import { defineStore } from 'pinia';

export const useDocNetSettingsStore = defineStore('docnet_settings', {
  state: () => ({
    useMockData: localStorage.getItem('docnet_demo_data') === 'true',
  }),
  actions: {
    toggleMockData() {
      this.useMockData = !this.useMockData;
      localStorage.setItem('docnet_demo_data', String(this.useMockData));
    },
  },
});
